
const addressRegex = /^0x[a-fA-F0-9]{40}$/;

export function isEthAddress(value: string) {
    return addressRegex.test(value);
}

export const ETH_ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";
